import { render, staticRenderFns } from "./PartItem.vue?vue&type=template&id=6e7e2dc3&scoped=true&"
import script from "./PartItem.vue?vue&type=script&lang=ts&"
export * from "./PartItem.vue?vue&type=script&lang=ts&"
import style0 from "./PartItem.vue?vue&type=style&index=0&id=6e7e2dc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e2dc3",
  null
  
)

export default component.exports